import { connect } from 'react-redux';
import Home from 'pages/Home';

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

function mapStateToProps(state) {
  return {
    pageTitle: state.website.title,
    sections: state.website.sections
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);


// WEBPACK FOOTER //
// ./src/containers/Home.container.js